import { Attributes, Misc, ModelBase, NeoModel, Rules } from "@singularsystems/neo-core";

@NeoModel
export default class CreateFileGroupingFileSpecCommand extends ModelBase {
    
    public staticServiceProviderFileGroupingId: number = 0;

    public staticFileSpecId: number = 0;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public activeStartDate: Date | null = null;

    @Attributes.Date(Misc.TimeZoneFormat.None)
    public activeEndDate: Date | null = null;

    @Rules.StringLength(200)
    public fileNameConvention: string = "";

    public ignoreFileInd: boolean = false;

    public isCriticalFileInd: boolean = false;

    @Rules.StringLength(3)
    public processSortOrder: string | null = null;
}